import { useToast } from "@agney/ir-toast";
import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../../../../../../constants";
import { utilService } from "../../../../../../../../services";
import { statusBoardService } from "../../../../../../StatusBoard.service";
import { statusBoardSocketService } from "../../../../../../StatusBoardSocketService";
import SwapTransferSearch from "../SwapTransferSearch/SwapTransferSearch";
import "./SwapTransferPopup.scss";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  showModal: boolean;
  inputData: any;
  onCancel: (data: boolean) => void;
}

const SwapTransferPopup: React.FC<ContainerProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  const patientData = props.inputData.patientData;
  const unitDetails = props.inputData.unitDetails[0].unit;
  const [MoveReminders, setMoveReminders] = useState<boolean>(true);
  const [MoveNotes, setMoveNotes] = useState<boolean>(true);
  const [MoveSms, setMoveSms] = useState<boolean>(true);
  const [selectedUnitId, setSelectedUnitId] = useState();
  const [selectedBedId, setSelectedBedId] = useState();
  const [showSignInAlertForNote, setShowSignInAlertForNote] = useState(false);
  const [userName, setUserName] = useState<string>("");
  const [userPassword, setUserPassword] = useState<string>("");
  const [isFormValid, setFormStatus] = useState(false);
  const [isInvalidCredentials, setSignInValidations] = useState(false);
  const [isShowPassword, setPasswordStatus] = useState(false);

  const Toast = useToast();

  useEffect(() => {
    setFormStatus(formValidation());
  }, [userName, userPassword]);

  const formValidation = () => {
    return userName && userPassword ? true : false;
  };

  const sendResponse = () => {
    const params = {
      action_username: userName,
      action_password: userPassword,
      toBedId: selectedBedId,
      fromBedId: patientData && patientData.id ? patientData.id : undefined,
      moveReminders: MoveReminders,
      moveNotes: MoveNotes,
      moveSms: MoveSms,
      type: props.inputData.changeType.id.toString(),
      reg_code: utilService.getNetwork(),
    };
    swapOrTransferPatient(params);
  };

  const swapOrTransferPatient = async (params: any) => {
    const respResult: any = await statusBoardService.updatePatientBedNo(params);
    if (respResult.isSuccess) {
      const type = props.inputData.changeType.id == 2 ? "Swap" : "Transfer";
     Toast.success(
  t("swapTransferSuccess", {
    type: props.inputData.changeType.name,
  })
);
      const socketParams = {
        socketType: CONSTANTS.SOCKET_TYPE.SWAP_TRANSFER,
        bedId: patientData.id,
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);
      onCancel(true);
      statusBoardService.isBedSwappedOrTransferredId = params.toBedId;
      statusBoardService.isBedSwappedOrTransferredFromId = params.fromBedId;
    } else {
      setSignInValidations(true);
    }
  };

  const onCancel = (status: boolean) => {
    props.onCancel(status);
  };
  const getSelectedUnitId = (data: any) => {
    setSelectedUnitId(data);
  };
  const getSelectedBedId = (data: any) => {
    setSelectedBedId(data);
  };

  const onShowPassword = () => {
    setPasswordStatus(!isShowPassword);
  };

  return (
    <>
      <IonModal
        isOpen={props.showModal}
        backdropDismiss={false}
        className="swap-transfer-popup"
      >
        <IonHeader id="containerWidth"></IonHeader>
        <IonContent>
          <div className="swap-transfer-container">
            <div className="icon-container">
              <div
                className="icon-close "
                onClick={() => {
                  onCancel(false);
                }}
              ></div>
            </div>

            <div className="header-text capital-text">
              {props.inputData.changeType.name}
            </div>
            <div className="search-label">
            {t("swapTransferLabel", {
  action: props.inputData.changeType.name,
  patient: patientData?.patient?.value,
  bed: patientData?.room?.value,
  unit: unitDetails?.unitName,
})}
            </div>
            <div className="left-container border-sep">
              <SwapTransferSearch
                type="unit"
                unitDetails={props.inputData}
                changeType={props.inputData.changeType}
                sendSelectedCardId={getSelectedUnitId}
                patientData={patientData}
              ></SwapTransferSearch>
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonCheckbox
                        className="move-checkbox"
                        checked={MoveReminders}
                        onClick={(e) =>
                          setMoveReminders(e.currentTarget.checked)
                        }
                      ></IonCheckbox>
                     <IonLabel>{t("moveReminders")}</IonLabel>

                    </IonItem>
                  </IonCol>

                  <IonCol>
                    <IonItem>
                      <IonCheckbox
                        className="move-checkbox"
                        checked={MoveNotes}
                        onClick={(e) => setMoveNotes(e.currentTarget.checked)}
                      ></IonCheckbox>
                    <IonLabel>{t("moveNotes")}</IonLabel>

                    </IonItem>
                  </IonCol>
                </IonRow>

                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonCheckbox
                        className="move-checkbox"
                        checked={MoveSms}
                        onClick={(e) => setMoveSms(e.currentTarget.checked)}
                      ></IonCheckbox>

                     <IonLabel>{t("moveSms")}</IonLabel>
                    </IonItem>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>
            <div className="left-container">
              <SwapTransferSearch
                type="bed"
                unitDetails={props.inputData}
                changeType={props.inputData.changeType}
                sendSelectedCardId={getSelectedBedId}
                patientData={patientData}
                unitId={selectedUnitId}
              ></SwapTransferSearch>

              <div className="swap-btn-cont">
                <IonButton
                  className="btn swap-cancel-btn "
                  onClick={() => {
                    onCancel(false);
                  }}
                >
                <span>{t("cancel")}</span>
                </IonButton>
                <IonButton
                  className="btn swap-send-btn"
                  disabled={selectedBedId == undefined}
                  onClick={() => {
                    // sendResponse();
                    setShowSignInAlertForNote(true);
                  }}
                >
                  <span>{props.inputData.changeType.name}</span>
                </IonButton>
              </div>
            </div>
          </div>
        </IonContent>
      </IonModal>
      <IonModal
        isOpen={showSignInAlertForNote}
        backdropDismiss={false}
        className="add-fav-modal sign-In-modal"
      >
        <div className="label-div">
          <div className="label-name">{t("signIn")}</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowSignInAlertForNote(false);
            }}
          ></div>
        </div>
        <form className="sign-in-input-container" autoComplete="off">
          <div className="signin-input-wrapper">
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                 {t("username")}
              </IonLabel>
              <IonInput
                className="ion-input"
                name="username"
                type="search"
                value={userName}
                onIonChange={(event) => {
                  setUserName(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="off"
                maxlength={25}
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-input-wrapper">
            <div
              className={`input-icon clickable ${
                isShowPassword ? "icon-show_password" : "icon-hide_password"
              }`}
              onClick={onShowPassword}
            ></div>
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                 {t("password")}
              </IonLabel>
              <IonInput
                className="ion-input"
                type={isShowPassword ? "text" : "password"}
                name="password"
                value={userPassword}
                onIonChange={(event) => {
                  setUserPassword(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="new-password"
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-validations" hidden={!isInvalidCredentials}>
           {t("invalidCredentials")}
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setUserName("");
                setUserPassword("");
              }}
            >
               {t("clear")}
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            <IonButton
              disabled={!isFormValid}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                sendResponse();
              }}
            >
              {t("signIn")}
            </IonButton>
          </div>
        </div>
      </IonModal>
    </>
  );
};

export default SwapTransferPopup;
